// extracted by css-extract-rspack-plugin
export default {"actionButton":"DatabaseConnectionInfoSection-module__actionButton___JRDYz"};